<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/cms/funnels'">Funnels</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add funnel</span>
      } @else {
        <span class="fs-5 fw-bold mb-0">Edit funnel</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">

      <div class="panel-container">
        <div class="panel-center">
          <div class="funnel-container">
            <div class="funnel" [ngClass]="{'moving-link':movingLink}" [ngStyle]="getFunnelStyle()"
                 (mousemove)="move($event)"
                 (mouseup)="stopMovingPage()" (mousedown)="clearSelection()" #funnelContainer>
              @for (link of links; track link) {
                <svg class="funnel-page-link">
                  <path class="link" [attr.d]="getLinkSvgPath(link)" (mousedown)="selectLink($event, link)"/>
                  <path class="arrow" [attr.d]="getLinkSvgArrowPath(link)"/>
                </svg>
              }

              @if (movingLink) {
                <svg class="funnel-page-link new-link">
                  <path class="link" [attr.d]="getLinkSvgPath(movingLink)"/>
                  <path class="arrow" [attr.d]="getLinkSvgArrowPath(movingLink)"/>
                </svg>
              }

              @for (page of pages; track page.id) {
                <div class="funnel-page" [ngStyle]="getPageStyle(page)" (mousemove)="movePage($event, page)"
                     [ngClass]="getPageClass(page)">
                  <div class="d-flex justify-content-between funnel-page-title"
                       (mousedown)="startMovingPage($event, page)">
                    <div class="funnel-page-name">
                      @switch (page.type) {
                        @case ('url') {
                          <i class="bi bi-link"></i>
                        }
                        @case ('static-page') {
                          <i class="bi bi-file-earmark"></i>
                        }
                      }
                      @if (isStartPage(page)) {
                        <i class="bi bi-play-btn-fill ms-1"></i>
                      }
                      @if (!isRegisterLead(page)) {
                        <i class="bi bi-person-dash-fill ms-1 text-warning" title="Lead not registered on this page"></i>
                      }
                      {{ page.name }}
                    </div>
                    <div class="funnel-page-id">
                      @if (page.id && page.id > 0) {
                        #{{ page.id }}
                      } @else {
                        <i class="bi bi-node-plus-fill"></i>
                      }
                    </div>
                  </div>
                  <div class="p-1">
                    <div class="funnel-page-slug">
                      <span class="fw-bold">Slug:</span>
                      /{{ page.slug }}
                    </div>
                    @if (page.type === 'url') {
                      <div class="funnel-page-url">
                        <span class="fw-bold">URL:</span>
                        &nbsp;<a [href]="page.url" target="_blank">{{ page.url }}</a>
                      </div>
                    }
                  </div>
                  <div class="dropdown funnel-page-menu">
                    <button class="btn btn-small funnel-page-menu-button" href="#" role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                      <i class="bi bi-list"></i>
                    </button>

                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item" [ngClass]="{'disabled':isStartPage(page)}"
                             (click)="setStartPage(page)">
                        <i class="bi bi-play-btn-fill me-2"></i> Set as start page
                      </a></li>
                      <li><a class="dropdown-item" appConfirm (click)="deletePage(page)">
                        <i class="bi bi-trash-fill me-2"></i>
                        Delete
                      </a></li>
                    </ul>
                  </div>
                  <div class="anchor-previous" (click)="startLinkPage($event, page)"></div>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="panel-tools">
          <ul class="nav nav-tabs mb-2" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link text-primary fw-bold" [ngClass]="{active:tabTools==='parameters'}"
                      type="button" (click)="tabTools='parameters'">Funnel
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link text-primary fw-bold" [ngClass]="{active:tabTools==='pages'}"
                      type="button" (click)="tabTools='pages'">Pages
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link text-primary fw-bold" [ngClass]="{active:tabTools==='properties'}"
                      type="button" (click)="tabTools='properties'">Properties
              </button>
            </li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane fade" [ngClass]="{active:tabTools==='parameters',show:tabTools==='parameters'}">
              <form [formGroup]="form" (ngSubmit)="save()" id="funnel">
                <label for="name" class="form-label">Name</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-tag"></i></span>
                  <input type="text" id="name" class="form-control" formControlName="name">
                </div>

                <label for="product" class="form-label">Brand</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-box"></i></span>
                  <select id="product" class="form-select" formControlName="productId" (change)="refreshLocales()">
                    <option [ngValue]="null">Select brand</option>
                    @for (product of products; track product.id) {
                      <option [ngValue]="product.id">{{ product }}</option>
                    }
                  </select>
                </div>

                <label for="lang" class="form-label">Language</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-translate"></i></span>
                  <select id="lang" class="form-select" formControlName="lang" (change)="refreshDomains()">
                    <option [ngValue]="null">All languages</option>
                    @for (locale of availableLocales; track locale) {
                      <option [ngValue]="locale">{{ locale }}</option>
                    }
                  </select>
                </div>

                <label for="domain" class="form-label">Domain</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-link"></i></span>
                  <select id="domain" class="form-select" formControlName="domainId">
                    <option [ngValue]="null" disabled>Select domain ({{ availableDomains.length }})</option>
                    @for (availableDomain of availableDomains; track availableDomain.id) {
                      <option [ngValue]="availableDomain.id">{{ availableDomain }}</option>
                    }
                  </select>
                  @if (availableDomainLoading) {
                    <span class="input-group-text"><span class="spinner-border spinner-border-sm"></span></span>
                  }
                </div>

                <label for="slug" class="form-label">Slug</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-link"></i></span>
                  <input type="text" id="slug" class="form-control" formControlName="slug">
                </div>

                <label for="startPage" class="form-label">Start page</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-play-btn-fill"></i></span>
                  <select id="startPage" class="form-select" formControlName="startPage">
                    <option [ngValue]="null" disabled>Select start page</option>
                    @for (page of pages; track page) {
                      <option [ngValue]="page">{{ page.staticPage?.name }}</option>
                    }
                  </select>
                </div>

                <div class="d-flex justify-content-end mt-2">
                  <app-input-switch formControlName="enabled" onLabel="Enabled"
                                    offLabel="Disabled"></app-input-switch>
                </div>
              </form>
            </div>

            <div class="tab-pane fade" [ngClass]="{active:tabTools==='pages',show:tabTools==='pages'}">
              <div class="accordion" id="accordionStaticPages">
                <label class="form-label">Add a new page</label>
                @for (pageType of pageTypes; track pageType.id) {
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                              [attr.data-bs-target]="'#accordion-page-type-' + pageType.id" aria-expanded="false"
                              [attr.aria-controls]="'accordion-page-type-' + pageType.id">
                        {{ pageType.name }} ({{ getStaticPagesByType(pageType).length }})
                      </button>
                    </h2>
                    <div [id]="'accordion-page-type-' + pageType.id" class="accordion-collapse collapse"
                         data-bs-parent="#accordionStaticPages">
                      <div class="accordion-body">
                        <ul class="static-pages">
                          @for (staticPage of getStaticPagesByType(pageType); track staticPage.id) {
                            <li class="d-flex justify-content-between">
                              <div class="p-2">
                                <div class="fw-bold">{{ staticPage.name }}</div>
                                <div>
                                  <i class="bi bi-link-45deg"></i>
                                  /{{ staticPage.slug }}
                                </div>
                              </div>
                              <button class="btn btn-primary" (click)="createPage(staticPage)"><i
                                class="bi bi-plus-circle"></i></button>
                            </li>
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                }

                <label class="form-label mt-3">Add a new external link</label>
                <div class="input-group">
                  <button class="btn btn-primary btn-sm" (click)="createExternalLink()">External link<i
                    class="bi bi-plus-circle ms-2"></i></button>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" [ngClass]="{active:tabTools==='properties',show:tabTools==='properties'}">
              @if (selectedPage) {
<!--                <form [formGroup]="formPageProperty" (ngSubmit)="applyPage()">-->
                  <label for="name" class="form-label">Name</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-card-text"></i></span>
<!--                    <input type="text" id="name" class="form-control" formControlName="name">-->
                    <input type="text" id="name" class="form-control" [(ngModel)]="selectedPage.name">
                  </div>

                  <label for="name" class="form-label">Type</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-card-text"></i></span>
                    <select id="name" class="form-select" [(ngModel)]="selectedPage.type">
                      <option value="static-page">Page</option>
                      <option value="url">URL</option>
                    </select>
                  </div>

                  @switch (selectedPage.type) {
                    @case ('url') {
                      <label for="url" class="form-label">URL</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-link"></i></span>
                        <input type="text" id="url" class="form-control" [(ngModel)]="selectedPage.url">
                        <button class="btn btn-outline-primary" (click)="editUrl()" type="button"><i class="bi bi-pencil"></i>
                        </button>
                      </div>
                    }
                    @case ('static-page') {
                      <label for="url" class="form-label">Page</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-file-earmark"></i></span>
                        <select id="url" class="form-select" [(ngModel)]="selectedPage.staticPage">
                          <option disabled>--- Select a page ---</option>
                          @for (staticPage of staticPages; track staticPage.id) {
                            <option [ngValue]="staticPage">#{{ staticPage.id }} - {{ staticPage.name }}</option>
                          }
                        </select>
                      </div>
                    }
                  }

                  <label for="slug" class="form-label">Slug</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-link"></i></span>
                    <input type="text" id="slug" class="form-control" [(ngModel)]="selectedPage.slug">
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <label for="positionX" class="form-label">Position X</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-123"></i></span>
                        <input type="number" id="positionX" class="form-control" [(ngModel)]="selectedPage.positionX">
                      </div>
                    </div>

                    <div class="col-md-6">
                      <label for="positionY" class="form-label">Position Y</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-123"></i></span>
                        <input type="number" id="positionY" class="form-control" [(ngModel)]="selectedPage.positionY">
                      </div>
                    </div>
                  </div>

                  @if (selectedPage.type === 'static-page') {
                    <label class="form-label">Lead registration</label>
                    <div>
                      <app-input-switch [ngModel]="isRegisterLead(selectedPage)"
                                        (ngModelChange)="setRegisterLead(selectedPage, $event)"
                                        onLabel="Register lead on form submit"
                                        offLabel="Register lead on form submit"></app-input-switch>
                    </div>
                  }

<!--                  <div class="text-end mt-3">-->
<!--                    <button class="btn btn-primary btn-sm">Apply</button>-->
<!--                  </div>-->
<!--                </form>-->
              } @else if (selectedLink) {
                <div class="text-end">
                  <button type="button" class="btn btn-danger btn-sm" (click)="deleteLink(selectedLink)">
                    <i class="bi bi-trash"></i>
                    Delete link
                  </button>
                </div>

                <label class="form-label">From</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="bi bi-box-arrow-right"></i>
                  </span>
                  <span class="form-control">{{ selectedLink.previousPage }}</span>
                </div>

                <label class="form-label">To</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="bi bi-box-arrow-in-right"></i>
                  </span>
                  <span class="form-control">{{ selectedLink.nextPage }}</span>
                </div>

                <label class="form-label mt-5">Conditions</label>
                <div class="d-flex">
                  <select class="form-select me-2" [(ngModel)]="linkConditionType">
                    <option disabled [ngValue]="null">Select condition</option>
                    @for (conditionType of linkConditionTypes; track conditionType.id) {
                      <option
                        [ngValue]="conditionType.id">{{ ('FunnelLinkConditionType.' + conditionType.id) | translate }}
                      </option>
                    }
                  </select>
                  <button type="button" class="btn btn-primary btn-sm" (click)="addLinkCondition(selectedLink)"
                          [disabled]="linkConditionType===null">Add&nbsp;condition
                  </button>
                </div>
                <div class="mt-2">
                  @for (condition of selectedLink.link?.conditions; track condition) {
                    @if (!$first) {
                      <div class="form-label text-center mt-1">AND</div>
                    }
                    @switch (condition.type) {
                      @case ('lead_status') {
                        <div class="d-flex align-items-center mt-1">
                          <span class="text-nowrap form-label">Lead Status</span>
                          <select class="form-select ms-1" [(ngModel)]="condition.params['condition']">
                            <option [ngValue]="'equal'">Equal to</option>
                            <option [ngValue]="'not-equal'">Not Equal to</option>
                          </select>
                          <select class="form-select ms-1" [(ngModel)]="condition.params['value']">
                            <option [ngValue]="'ok'">OK</option>
                            <option [ngValue]="'ko'">KO</option>
                            <option [ngValue]="'already_reagistered'">Already registered</option>
                            <option [ngValue]="'reactivated'">Reactivated</option>
                            <option [ngValue]="'p0'">Pre-registration (p0)</option>
                          </select>
                          <button type="button" class="btn btn-sm btn-danger ms-1" appConfirm
                                  (click)="removeLinkCondition(selectedLink, condition)">
                            <i class="bi bi-trash"></i>
                          </button>
                        </div>
                      }
                      @default {
                        Unknown condition !
                      }
                    }
                  }
                </div>
              } @else {
                <span>No element selected</span>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="text-end mt-3">
        <button type="submit" class="btn btn-primary fw-bold" form="funnel">
          @if (isCreate()) {
            Create
          } @else {
            Update
          }
        </button>
      </div>
    </div>
  </div>
}
